import { API } from "./utils"

export const crd = {
  crdFilesList: (params = null) => API.get("/crd/files/", { params }),
  uniqueMWNList: (params = null) => API.get("/crd/unique-mwns/", { params }),
  uniqueMWNMatch:  (id, data) => API.post(`/crd/unique-mwns/${id}/match/`, data),
  uniqueMWNCandidatesList:  (id, params) => API.get(`/crd/unique-mwns/${id}/candidates/`, params),
}
